<template>
    <div>
      <Pos_inventory_detail/>
    </div>
  </template>
  
  <script>
  import Pos_inventory_detail from "@/components/adminArin/pos_system/warehouse/inventory/Pos_inventory_detail";
  export default {
    name: "PosInventoryDetail",
    components: {
      Pos_inventory_detail
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  